/* eslint-disable react/destructuring-assignment */

import * as React from 'react';
import { ParticipantState } from 'stageclip-common';

import styles from './participantsState.module.scss';

interface ParticipantsStateOwnProps {
  state: any;
}

export class ParticipantsState extends React.Component<ParticipantsStateOwnProps> {
  private static renderState(value: string, className: string) {
    return <span className={className}>{value}</span>;
  }

  private static getStateCell(state: ParticipantState) {
    switch (state) {
      case ParticipantState.Processing:
        return ParticipantsState.renderState('Processing', styles.processingState);
      case ParticipantState.Processed:
        return ParticipantsState.renderState('Processed', styles.processedState);
      case ParticipantState.ReadyToGenerateClip:
        return ParticipantsState.renderState('Clipped', styles.readyToGenerateState);
      case ParticipantState.Error:
        return ParticipantsState.renderState('Error', styles.errorState);
      case ParticipantState.New:
        return ParticipantsState.renderState('New', styles.newState);
      case ParticipantState.SentToGenerator:
        return ParticipantsState.renderState('Sent to generator', styles.sentToGenerator);
      default:
        return ParticipantsState.renderState(state, styles.state);
    }
  }

  public render() {
    return ParticipantsState.getStateCell(this.props.state);
  }
}
